<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0',
        parseInt(item.description) >= 70 &&
          parseInt(item.description) <= 110 &&
          'color-green',
        parseInt(item.description) >= 51 &&
          parseInt(item.description) <= 69 &&
          'color-orange',
        parseInt(item.description) >= 111 &&
          parseInt(item.description) <= 125 &&
          'color-orange',
        (parseInt(item.description) >= 126 ||
          parseInt(item.description) <= 51) &&
          'color-red',
      ]"
    >
      {{ item.description }}
      {{ item.abbreviation }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "GlicemiaCapilar",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>